import Immutable from 'immutable';

const StudentUnitQuizResultRecord = Immutable.Record({
  studentId: undefined,
  unitQuizResults: undefined,
});

class StudentUnitQuizResult extends StudentUnitQuizResultRecord { }

export default StudentUnitQuizResult;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/model.js